import { Tabs, Tab, styled } from '@mui/material';

export const TabContainer = styled('div')(() => ({
  width: '100%',
  backgroundColor: `var(--color-white)`,
  borderBottom: '1px solid var(--color-greyscale-100)',
}));

export const StyledTabs = styled(Tabs)(() => ({
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTabs-flexContainer': {
    gap: '8px',
    padding: '0 16px',
    height: '100%',
    alignItems: 'center',
  },
}));

export const StyledTab = styled(Tab)(() => ({
  fontFamily: 'Rubik',
  width: '70px',
  maxHeight: '24px',
  minHeight: '24px',
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '16px',
  fontStyle: 'normal',
  borderRadius: '8px',
  color: 'var(--color-greyscale-600)',
  transition: 'all 0.2s ease-in-out',
  '&:hover': {
    color: 'var(--color-greyscale-800)',
    backgroundColor: 'var(--color-secondary-100)',
  },
  '&.Mui-selected': {
    fontWeight: 400,
    color: 'var(--color-greyscale-800)',
    backgroundColor: 'var(--color-secondary-100)',
  },
}));
